import * as React from "react"
import { SubscriptionPlan, SubscriptionStatus } from "@modules/graphql/types"
import {
  PlanIndicator,
  PlanIndicatorPlanType,
} from "@modules/billing/shared/components/PlanIndicator"

const mapPlanNameToType: Record<string, PlanIndicatorPlanType | undefined> = {
  Free: `FREE`,
  Professional: `PROFESSIONAL`,
  Business: `BUSINESS`,
  Enterprise: `ENTERPRISE`,
  "Pro (InkTeam)": `PROFESSIONAL`,
  Individual: `INDIVIDUAL`,
  Team: `TEAM`,
}

export type OrganizationPlanBadgeProps = {
  billingStatus: SubscriptionStatus
  planName: SubscriptionPlan["name"]
}

export function OrganizationPlanBadge({
  billingStatus,
  planName,
}: OrganizationPlanBadgeProps) {
  let planIndicatorType = mapPlanNameToType[planName]

  // Backwards compatibility for old, Professional trials
  if (planName === `Trialing`) {
    planIndicatorType = `PROFESSIONAL`
  }

  if (!planIndicatorType) {
    return null
  }

  return <PlanIndicator planType={planIndicatorType} status={billingStatus} />
}
